
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerEditor()
    export class PsFuncKbMapShiftCodeEditor extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PsFuncKbMapShiftCodeRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PsFuncKbMapShiftCodeRow.lookupKey;
        }

        protected getItemText(item, lookup) {
            return super.getItemText(item, lookup) + ' ('+item.KbMapShiftCode+')';
        }
    }
}
